import api from '@pray/shared/utils/api';

export type RetryAllWorkflowResponse = {
  data: {
    triggered_count: number;
    message: string;
  };
};

export async function retryAllWorkflow(): Promise<RetryAllWorkflowResponse> {
  const url = '/web/studio/system-check/workflow/retry-all';
  const response = await api.executePostRequest<RetryAllWorkflowResponse>(url);

  return response.data;
}
